import { createCustomEvent } from "../../../../javascript/shared/helpers"

export default class extends Controller {
  static targets = ["mainContentPane"]

  connect() {
    this.fetchContentFor = this.fetchContentFor.bind(this)
    this.replaceMainContent = this.replaceMainContent.bind(this)
    App.Helpers.listenToCustomEvent(document, "primary-content-pane-load:trigger", this.fetchContentFor)
    App.Helpers.listenToCustomEvent(document, "primary-content-pane-load:success", this.replaceMainContent)
  }

  replaceMainContent({ detail }) {
    const { html } = detail
    App.Helpers.setContentFromString(this.mainContentPaneTarget, html)
  }

  fetchContentFor({ detail }) {
    const { contentTitle, contentURL: url } = detail
    url && App.Helpers.ajaxRequest({
      url,
      successHandler: (html => {
        document.dispatchEvent(
          createCustomEvent("primary-content-pane-load:success", this.element, { html, contentTitle })
        )
      }).bind(this)
    })
  }
}



// WEBPACK FOOTER //
// ./app/components/my_via/assets/javascript/my-via-index-controller.js